import { defineEvent } from '../types/event';
export var YOTPO_INIT = defineEvent({
    platforms: [
        {
            name: 'GTM',
            alias: 'initYotpoNew'
        }
    ]
});
